export const UPDATE_USER_TEST = "/user_test/access_report"
export const UPDATE_BETESA = "/betesa_result/general_data/"
export const GET_COBRANDING = "/cobranding"
export const BACK_PAGE = -1;

